<!-- 新闻 -->
<template>
  <div class="tab-container">
    <el-card style="margin-top: 25px">
      <div class="filter-container">
        <div>
          <i class="el-icon-search"></i>
          <span>筛选搜索</span>
        </div>
        <div style="margin-top: 15px">
          <el-form
            :inline="true"
            label-width="120px"
            ref="search"
            size="small"
            :label-position="labelPosition"
          >
            <el-form-item label="标题">
              <el-input
                placeholder="请输入标题"
                v-model="listQuery.title"
              ></el-input>
            </el-form-item>
            <el-form-item label="发布位置">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="listQuery.fbposition"
              >
                <el-option
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id"
                  v-for="item in positions"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保存时间">
              <el-date-picker
                @change="changTime"
                clearable
                end-placeholder="结束日期"
                range-separator="至"
                size="small"
                start-placeholder="开始日期"
                type="daterange"
                v-model="value1"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <!-- 新的审核状态： -->
            <el-form-item label="审核状态">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="selectValue"
                @change="selectStatus"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in newsStatus"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="排序">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="sortTime"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in sortData"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否上首页">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="homeIn"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in homeInOn"
                ></el-option>
              </el-select>
            </el-form-item>
            <div>
              <el-form-item>
                <el-button
                  @click="searchNewsList()"
                  size="mini"
                  style="float: right; margin-left: 100px"
                  type="primary"
                  v-if="menuPerm('news:list')"
                  >查询</el-button
                >
              </el-form-item>
              <!-- 发布者  v-if="reviewerUser" -->
              <el-form-item>
                <el-button
                  @click="handleCreate"
                  class="filter-item"
                  icon="el-icon-edit"
                  size="mini"
                  style="float: right; flex: auto; margin-left: 30px"
                  type="primary"
                  v-if="menuPerm('news:add')"
                  >添加</el-button
                >
              </el-form-item>
              <!-- 审核者  v-if="publisherUser"-->
              <el-form-item>
                <el-button
                  @click="handleExamSubmit"
                  class="filter-item"
                  size="mini"
                  style="
                    float: right;
                    flex: auto;
                    margin-left: 30px;
                    width: 100px;
                  "
                  type="primary"
                  v-if="menuPerm('news:batch_review')"
                  >批量审核通过</el-button
                >
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>

      <!-- 数据 -->
      <!-- list.slice((currentPage-1)*pagesize,currentPage*pagesize) -->
      <el-table
        :data="list"
        @selection-change="handleSelectionChange"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
        :header-cell-style="getRowClass"
      >
        <!-- 多选-->
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="标题" prop="newsTitle" width="200">
          <template slot-scope="scope">
            <a-tooltip>
              <!-- <template slot="title">{{ scope.row.newsTitle }}</template> -->
              <a :title="scope.row.newsTitle" style="color: #606266">
                <span class="news_title">{{ scope.row.newsTitle }}</span>
              </a>
            </a-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column label="海报" prop="poster" width="100">
          <template slot-scope="scope">
              <img :src="scope.row.poster" :preview="scope.row.id" alt="" style="height: 150px" />
          </template>
        </el-table-column> -->
        <el-table-column label="状态" prop="examineStatus">
          <template slot-scope="scope">
            <span v-if="scope.row.examineStatus == 2">未提交审核</span>
            <span v-if="scope.row.examineStatus == 3">审核中</span>
            <span v-if="scope.row.examineStatus == 4">审核未通过</span>
            <span v-if="scope.row.examineStatus == 1">审核通过</span>
          </template>
        </el-table-column>

        <el-table-column label="发布位置" prop="menuName"></el-table-column>

        <!-- <el-table-column label="送审时间" prop="submitReviewTimestamp"></el-table-column>
        <el-table-column label="审核时间" prop="createTimestamp"></el-table-column>-->

        <el-table-column label="链接" prop="linkTo" width="120px">
          <template slot-scope="{ row }">
            <!-- <span class="link_text">{{ 'https://www.weiguanzixun.com/share?id='+row.id }}</span> -->
            <el-button
              @click="copy"
              size="mini"
              type="primary"
              class="btns"
              :data-clipboard-text="
                'https://www.weiguanzixun.com/share?id=' + row.id
              "
              >复制</el-button
            >
          </template>
        </el-table-column>

        <el-table-column label="权重" prop="sort"></el-table-column>

        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          width="400px"
        >
          <template slot-scope="{ row, $index }">
            <div>
              <!-- v-if="publisherUser" -->
              <el-button
                @click="handleTime($index)"
                size="mini"
                type="primary"
                v-if="menuPerm('news:update_sort')"
                >修改权重</el-button
              >
              <!-- v-if="publisherUser" -->
              <el-button
                @click="handleModify($index)"
                size="mini"
                type="primary"
                v-if="menuPerm('news:zhushui')"
                >注水</el-button
              >
              <!-- v-if="reviewerUser" -->
              <el-button
                @click="handleUpdate(row)"
                size="mini"
                type="primary"
                v-if="menuPerm('news:edit')"
                :disabled="
                  row.examineStatus == 1 ||
                  row.examineStatus == 3 ||
                  row.examineStatus == 5 ||
                  editOpen
                    ? true
                    : false
                "
                >编辑</el-button
              >

              <!-- :disabled="row.disabled   || editOpen    ? true : false" -->
              <!-- v-if="reviewerUser" -->
              <el-button
                @click="handleExamine(row)"
                size="mini"
                type="primary"
                v-if="menuPerm('news:subexam')"
                :disabled="
                  row.examineStatus == 2 || row.examineStatus == 4
                    ? false
                    : true
                "
              >
                提交审核
                <!-- {{$store.state.disOpen}} -->
              </el-button>
              <el-button
                size="mini"
                type="primary"
                @click="push(row)"
                v-if="menuPerm('app:push')"
              >
                推送
                <!-- {{$store.state.disOpen}} -->
              </el-button>
              <!-- 提交审核  v-if="publisherUser"-->
              <el-button
                @click="handleUpshenhe(row)"
                size="mini"
                type="primary"
                :disabled="
                  row.examineStatus == 3 || row.examineStatus == 1
                    ? false
                    : true
                "
                v-if="menuPerm('news:shenhe')"
                >审核</el-button
              >
              <el-button size="mini" type="primary" @click="changeTime(row.id)"
                v-if="menuPerm('news:setTime')"
                >修改时间</el-button
              >
              <!-- publisherUser -->
              <el-button
                @click="handleDelete(row.id, $index)"
                size="mini"
                type="danger"
                v-if="row.status != 'deleted' && menuPerm('news:delete')"
                >删除</el-button
              >
              <el-button
                @click="poster(row.id)"
                size="mini"
                type="primary"
                v-if="menuPerm('news:generatePoster')"
                >生成海报</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </el-card>
    <!--编辑-->
    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      style="z-index: 99"
      @close="editClose"
    >
      <el-form
        :model="editList"
        :rules="rules"
        label-position="left"
        label-width="70px"
        ref="form"
        style="width: 800px; margin-left: 50px"
      >
        <el-form-item label="标题" prop="newsTitle">
          <el-input
            maxlength="100"
            placeholder="请输入标题"
            show-word-limit
            v-model="editList.newsTitle"
          />
        </el-form-item>
        <el-form-item label="摘要" prop="摘要">
          <el-input
            maxlength="200"
            placeholder="请输入摘要"
            show-word-limit
            v-model="zhaiyao"
          />
        </el-form-item>
        <el-form-item label="是否热点">
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editList.isHotspot"
          ></el-checkbox>
        </el-form-item>
        <el-form-item label="是否首页" prop="expectIsRecommend">
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editList.isRecommend"
          ></el-checkbox>
        </el-form-item>
        <el-form-item label="封面样式" prop="fmStyle">
          <el-radio-group
            v-model="temp.fmStyle"
            style="width: 100%; margin-top: 10px"
          >
            <el-radio :label="1" id="logo" value="1"
              >一张小图(800*600)</el-radio
            >
            <el-radio :label="2" id="haitun" value="2"
              >三张小图(840*400)</el-radio
            >
            <el-radio :label="3" id="orange" value="3"
              >一张大图(750*600)</el-radio
            >
          </el-radio-group>
          <div style="width: 100%; position: relative; left: -5px; top: 0px">
            <img
              src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_1.png"
              style="width: 100px; height: 100px; margin-left: 30px"
            />
            <img
              src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_3.png"
              style="width: 100px; height: 100px; margin-left: 75px"
            />
            <img
              src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_2.png"
              style="width: 100px; height: 100px; margin-left: 80px"
            />
          </div>
        </el-form-item>
        <el-form-item label="封面图" style="margin-top: 53px !important">
          <el-upload
            :auto-upload="true"
            :file-list="imgList"
            :limit="3"
            :on-preview="removePreview"
            :on-remove="removeFacepic"
            :action="serverUrl"
            :headers="header"
            name="img"
            :on-success="editSuccess"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
            <el-button
              type="info"
              style="position: absolute; top: 168px; left: 0px"
              >本地图片</el-button
            >
          </el-upload>
          <div style="position: absolute; top: 158px; left: 110px">
            <el-button
              type="primary"
              style="width: 98px"
              @click="showModal('edit')"
              >内容图片</el-button
            >
          </div>
        </el-form-item>
        <a-modal
          class="dialogModal"
          v-model="visibleEdit"
          ok-text="确认"
          cancel-text="取消"
          @ok="hideModal('edit')"
        >
          <div v-for="(item, index) in imgArr" :key="index">
            <img :src="item" alt="" @click="contentImg(item, 'edit')" />
          </div>
        </a-modal>
        <el-form-item label="来源" prop="source" style="margin-top: 60px">
          <el-input
            maxlength="100"
            placeholder="请输入来源"
            show-word-limit
            v-model="editList.source"
          />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="推送位置">
              <el-select
                class="filter-item"
                clearable
                placeholder="请选择"
                size="small"
                v-model="editList.menuName"
              >
                <el-option
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id"
                  v-for="item in positions"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选择作者">
              <el-select placeholder="请选择" v-model="editList.publisherId">
                <el-option
                  v-for="item in author"
                  :key="item.id"
                  :label="item.nickName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 内容区 -->
        <el-form-item
          label="内容"
          prop="content"
          style="min-width: 1200px"
          ref="contentext"
        >
          <el-upload
            :action="serverUrl"
            :before-upload="beforeUpload"
            :headers="header"
            :on-error="uploadError"
            :on-success="uploadSuccess"
            :show-file-list="false"
            class="avatar-uploader"
            name="img"
          ></el-upload>
          <quill-editor
            :options="editorOption"
            @change="onEditorChange($event, 'edit')"
            ref="myTextEditor"
            style="width: 100%; height: 500px; padding-bottom: 100px"
            v-model="this.newsContent"
          ></quill-editor>
          <div :visible.sync="videoUploadTag">
            <el-dialog
              :visible.sync="videoUploadTag"
              append-to-body
              id="video_upload"
              style="margin-top: 1px"
              title="视频上传"
              width="50%"
            >
              <el-tabs
                @tab-click="videoSelectTagClick"
                v-model="activeName"
                value="0"
              >
                <el-tab-pane label="添加视频链接" name="first">
                  <el-input
                    clearable
                    placeholder="请输入视频链接"
                    v-model="videoLink"
                  ></el-input>
                  <el-button
                    @click="addVideoLink()"
                    size="small"
                    style="margin: 20px 0px 0px 0px"
                    type="primary"
                    >添加</el-button
                  >
                </el-tab-pane>
                <el-tab-pane label="上传本地视频" name="second"
                  ><a-upload
                    list-type="picture"
                    :action="serverUrl"
                    name="img"
                    :headers="header"
                    :supportServerRender="true"
                    :preview-file="previewFile"
                    @change="videoChange"
                  >
                    <a-button> <a-icon type="upload" /> 上传视频 </a-button>
                  </a-upload></el-tab-pane
                >
              </el-tabs>
            </el-dialog>
          </div>
        </el-form-item>
      </el-form>

      <div class="dialog-footer" slot="footer">
        <el-button
          @click="dialogStatus === 'create' ? createData() : updateData()"
          type="primary"
          v-if="menuPerm('news:edit')"
          >发布</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加新闻 -->
    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible1"
      v-if="show"
      @close="addClose"
      style="z-index: 99"
    >
      <el-form
        :model="editList"
        :rules="rulesAdd"
        label-position="left"
        label-width="120px"
        ref="ruleForm"
        style="width: 800px; margin-left: 50px"
      >
        <el-form-item label="标题" prop="newsTitle">
          <el-input
            placeholder="请输入标题"
            show-word-limit
            v-model="editList.newsTitle"
          />
        </el-form-item>
        <el-form-item label="摘要" prop="zhaiyao">
          <el-input
            placeholder="请输入摘要"
            show-word-limit
            v-model="editList.zhaiyao"
          />
        </el-form-item>
        <!-- 开关 -->
        <el-form-item label="是否热点">
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editList.isHotspot"
          ></el-checkbox>
        </el-form-item>
        <el-form-item label="是否首页" prop="expectIsRecommend">
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editList.isRecommend"
          ></el-checkbox>
        </el-form-item>
        <el-form-item label="封面样式" prop="fmStyle">
          <el-radio-group v-model="temp.fmStyle" style="margin-top: 10px">
            <el-radio :label="1" checked="true" id="logo" value="1"
              >一张小图(800*600)</el-radio
            >
            <el-radio :label="2" id="haitun" value="2"
              >三张小图(840*400)</el-radio
            >
            <el-radio :label="3" id="orange" value="3"
              >一张大图(750*600)</el-radio
            >
          </el-radio-group>
          <div style="width: 100%; position: relative; left: -5px; top: 0px">
            <img
              src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_1.png"
              style="width: 100px; height: 100px; margin-left: 30px"
            />
            <img
              src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_3.png"
              style="width: 100px; height: 100px; margin-left: 75px"
            />
            <img
              src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_2.png"
              style="width: 100px; height: 100px; margin-left: 80px"
            />
          </div>
        </el-form-item>
        <el-form-item
          label="封面图"
          style="margin-top: 50px"
          prop="fengImg"
          ref="fengImg"
        >
          <el-upload
            :auto-upload="true"
            :limit="3"
            :file-list="changeContentImg"
            :on-preview="removePreview"
            :on-remove="removeFace"
            :on-success="upSuccess"
            :action="serverUrl"
            :headers="myHeaders"
            name="img"
            list-type="picture-card"
            :disabled="this.disabledValue"
          >
            <i class="el-icon-plus"></i>
            <el-button
              type="info"
              style="position: absolute; top: 168px; left: 0px"
              >本地图片</el-button
            >
          </el-upload>
          <div style="position: absolute; top: 158px; left: 110px">
            <el-button type="primary" style="width: 98px" @click="showModal"
              >内容图片</el-button
            >
          </div>
        </el-form-item>
        <a-modal
          v-model="visible"
          ok-text="确认"
          cancel-text="取消"
          @ok="hideModal"
          style="display: flex; flex-wrap: wrap"
        >
          <div v-for="(item, index) in imgArr" :key="index">
            <img :src="item" alt="" @click="contentImg(item)" />
          </div>
        </a-modal>

        <el-form-item label="来源" prop="source" style="margin-top: 80px">
          <el-input
            placeholder="请输入来源"
            show-word-limit
            v-model="editList.source"
          />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="推送位置" prop="menuName">
              <el-select
                class="filter-item"
                clearable
                placeholder="请选择"
                size="small"
                v-model="editList.menuName"
              >
                <el-option
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id"
                  v-for="item in positions"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选择作者" prop="authorData">
              <el-select
                placeholder="请选择"
                v-model="editList.authorData"
                value-key="id"
              >
                <el-option
                  v-for="item in author"
                  :key="item.nickName"
                  :label="item.nickName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 内容区 -->
        <el-form-item
          label="内容"
          prop="content"
          style="min-width: 1000px; height: 600px"
          ref="contented"
          class="quills"
        >
          <!-- 上传视频 -->
          <el-upload
            :action="serverUrl"
            :before-upload="beforeUpload"
            :headers="header"
            :on-error="uploadError"
            :on-success="uploadSuccess"
            :show-file-list="false"
            class="avatar-uploader"
            name="img"
          ></el-upload>
          <!-- 富文本 -->
          <quill-editor
            :options="editorOption"
            @change="onEditorChange($event, 'add')"
            ref="myTextEditor"
            style="width: 100%; height: 500px; padding-bottom: 100px"
            v-model="editList.content"
          ></quill-editor>
          <!-- 添加视频链接 -->
          <div :visible.sync="videoUploadTag">
            <el-dialog
              :visible.sync="videoUploadTag"
              append-to-body
              id="video_upload"
              style="margin-top: 1px"
              title="视频上传"
              width="50%"
            >
              <el-tabs
                @tab-click="videoSelectTagClick"
                v-model="activeName"
                value="0"
              >
                <el-tab-pane label="添加视频链接" name="first">
                  <el-input
                    clearable
                    placeholder="请输入视频链接"
                    v-model="videoLink"
                  ></el-input>
                  <el-button
                    @click="addVideoLink()"
                    size="small"
                    style="margin: 20px 0px 0px 0px"
                    type="primary"
                    >添加</el-button
                  >
                </el-tab-pane>
                <el-tab-pane label="上传本地视频" name="second"
                  ><a-upload
                    list-type="picture"
                    :action="serverUrl"
                    name="img"
                    :headers="header"
                    :supportServerRender="true"
                    :preview-file="previewFile"
                    @change="videoChange"
                  >
                    <a-button> <a-icon type="upload" /> 上传视频 </a-button>
                  </a-upload></el-tab-pane
                >
              </el-tabs>
            </el-dialog>
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="addFalse" v-if="menuPerm('news:add')"
          >取消</el-button
        >
        <el-button
          @click="getissue('ruleForm')"
          type="primary"
          v-if="menuPerm('news:add')"
          >发布</el-button
        >
      </div>
    </el-dialog>
    <!--审核-->
    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible2"
      v-if="isBlock"
      @close="examClose"
    >
      <el-form
        :model="editList"
        :rules="rules"
        label-position="left"
        label-width="70px"
        ref="form"
        style="width: 800px; margin-left: 50px"
      >
        <el-form-item label="标题" prop="newsTitle">
          <el-input
            :disabled="true"
            placeholder="请输入标题"
            v-model="editList.newsTitle"
          />
        </el-form-item>
        <el-form-item label="摘要" prop="摘要">
          <el-input
            :disabled="true"
            placeholder="请输入摘要"
            v-model="zhaiyao"
          />
        </el-form-item>
        <!-- 开关 -->
        <el-form-item label="是否热点">
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editList.isHotspot"
          ></el-checkbox>
        </el-form-item>
        <el-form-item label="是否首页">
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editList.isRecommend"
          ></el-checkbox>
        </el-form-item>
        <el-form-item label="封面样式" prop="fmStyle">
          <el-radio-group
            :disabled="true"
            v-model="temp.fmStyle"
            style="margin-top: 10px"
          >
            <el-radio :label="1" id="logo" value="1"
              >一张小图(800*600)</el-radio
            >
            <el-radio :label="2" id="haitun" value="2"
              >三张小图(840*400)</el-radio
            >
            <el-radio :label="3" id="orange" value="3"
              >一张大图(750*600)</el-radio
            >
          </el-radio-group>
          <div style="width: 100%; position: relative; left: -5px; top: 0px">
            <img
              src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_1.png"
              style="width: 100px; height: 100px; margin-left: 30px"
            />
            <img
              src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_3.png"
              style="width: 100px; height: 100px; margin-left: 75px"
            />
            <img
              src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_2.png"
              style="width: 100px; height: 100px; margin-left: 80px"
            />
          </div>
        </el-form-item>
        <el-form-item label="封面图" style="margin-top: 30px">
          <el-upload
            :before-upload="beforeAvatarUpload"
            :class="{ hide: hideUploadCard }"
            :disabled="true"
            :file-list="imgList"
            :limit="3"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :show-file-list="true"
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            style="margin-top: 10px"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <span style="float: left; color: red" v-if="false"
            >只能上传3张图片</span
          >
          <el-dialog :visible.sync="dialogVisible">
            <img :src="dialogImageUrl" alt width="100%" />
          </el-dialog>
        </el-form-item>

        <el-form-item label="来源" prop="source">
          <el-input
            :disabled="true"
            placeholder="请输入来源"
            v-model="editList.source"
          />
        </el-form-item>
        <el-form-item label="推送位置">
          <el-select
            class="filter-item"
            clearable
            placeholder="请选择"
            size="small"
            v-model="editList.menuName"
          >
            <el-option
              :key="item.id"
              :label="item.menuName"
              :value="item.id"
              v-for="item in positions"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="content" style="min-width: 1200px">
          <el-upload
            :action="serverUrl"
            :before-upload="beforeUpload"
            :headers="header"
            :on-error="uploadError"
            :on-success="uploadSuccess"
            :show-file-list="false"
            class="avatar-uploader"
            name="img"
          ></el-upload>
          <quill-editor
            :options="editorOption"
            @change="onEditorChange($event)"
            @focus="onEditorFocus($event)"
            ref="myTextEditor"
            style="width: 100%; height: 500px; padding-bottom: 100px"
            v-model="editList.content"
          ></quill-editor>
          <div :visible.sync="videoUploadTag">
            <el-dialog
              :visible.sync="videoUploadTag"
              append-to-body
              id="video_upload"
              style="margin-top: 1px"
              title="视频上传"
              width="50%"
            >
              <el-tabs
                @tab-click="videoSelectTagClick"
                v-model="activeName"
                value="0"
              >
                <el-tab-pane label="添加视频链接" name="first">
                  <el-input
                    clearable
                    placeholder="请输入视频链接"
                    v-model="videoLink"
                  ></el-input>
                  <el-button
                    @click="addVideoLink()"
                    size="small"
                    style="margin: 20px 0px 0px 0px"
                    type="primary"
                    >添加</el-button
                  >
                </el-tab-pane>
                <el-tab-pane label="素材库" name="second">请期待</el-tab-pane>
              </el-tabs>
            </el-dialog>
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="noToExamine" v-if="menuPerm('news:shenhe')"
          >不通过</el-button
        >
        <el-button
          @click="toExamine"
          type="primary"
          v-if="menuPerm('news:shenhe')"
          >通过</el-button
        >
      </div>
    </el-dialog>
    <!-- 留言预览-->
    <el-dialog :visible.sync="liuyanDialogVisible" title="留言预览">
      <el-form :model="temp">
        <p>
          <span>{{ temp.title }}</span>
        </p>
        <p>
          <span>作者昵称</span>
        </p>
        <p>
          =================================================================================
        </p>
        <p>
          <span>富文本内容</span>
        </p>
        <img
          alt
          src="https://www.baidu.com/img/dongsc_eb45d000832f8e889ff64951eaf7f381.gif"
        />
        <!--放3张图片： 点赞数，观看数，转发数-->
        <div style="margin-bottom: 10px; flex: auto">
          <img
            alt
            src="https://news-icon.oss-cn-beijing.aliyuncs.com/521592200537_.pic_hd.jpg"
          />
          <span style="margin-left: 5px">10000</span>
          <img
            alt
            src="https://news-icon.oss-cn-beijing.aliyuncs.com/531592200542_.pic_hd.jpg"
            style="margin-left: 15px"
          />
          <span style="margin-left: 5px">10000</span>
          <img
            alt
            src="https://news-icon.oss-cn-beijing.aliyuncs.com/541592200547_.pic_hd.jpg"
            style="margin-left: 15px"
          />
          <span style="margin-left: 5px">10000</span>
        </div>

        <div class="line" style="margin-left: 100px"></div>
        <p>
          <span style="font-size: 15px">评论</span>
        </p>
        <p>
          <span>作者昵称</span>
        </p>
        <p>
          <span>评论内容</span>
        </p>
        <!--放3张图片： 点赞数，收藏数，转发数-->
        <div style="margin-bottom: 10px">
          <img
            alt
            src="https://news-icon.oss-cn-beijing.aliyuncs.com/521592200537_.pic_hd.jpg"
          />
          <img
            alt
            src="https://news-icon.oss-cn-beijing.aliyuncs.com/531592200542_.pic_hd.jpg"
            style="margin-left: 15px"
          />
          <img
            alt
            src="https://news-icon.oss-cn-beijing.aliyuncs.com/541592200547_.pic_hd.jpg"
            style="margin-left: 15px"
          />
          <el-button
            @click="checkPass"
            size="mini"
            style="margin-left: 650px"
            type="danger"
            v-show="isShow"
            >通过</el-button
          >
        </div>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="liuyanDialogVisible = false" type="primary"
          >返回</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改点赞数弹框 -->
    <div>
      <a-modal
        v-model="modifydialogVisible"
        title="注水"
        :footer="null"
        @cancel="handleCancel"
      >
        <el-form label-width="90px">
          <el-form-item label="点赞数">
            <a-input v-model="favorCount" />
            <a-button
              type="primary"
              @click="handleFavor"
              v-if="menuPerm('news:zhushui')"
              >修改</a-button
            >
          </el-form-item>
          <el-form-item label="观看数">
            <a-input v-model="watchCount" />
            <a-button
              type="primary"
              @click="handleWatch"
              v-if="menuPerm('news:zhushui')"
              >修改</a-button
            >
          </el-form-item>
        </el-form>
      </a-modal>
    </div>

    <!-- 修改时间权重弹框 -->
    <div>
      <a-modal v-model="timedialogVisible" title="修改新闻权重" :footer="null">
        <el-date-picker
          v-model="sorts"
          type="datetime"
          placeholder="选择日期时间"
          format="yyyy-MM-dd HH:mm:ss"
          @change="TimeChange"
        ></el-date-picker>
        <a-button
          type="primary"
          @click="EditTime"
          v-if="menuPerm('news:update_sort')"
          style="position: relative; left: 8px"
          >修改</a-button
        >
      </a-modal>
    </div>
    <!-- 修改时间 -->
    <div>
      <a-modal v-model="changeTimeVisible" title="修改时间" :footer="null">
        <el-date-picker
          v-model="timeValue"
          type="datetime"
          placeholder="选择日期时间"
          @change="TimeSelect"
        ></el-date-picker>
        <a-button type="primary" @click="sureChangeTime">修改</a-button>
      </a-modal>
    </div>

    <!-- 注水 -->
    <el-dialog :visible.sync="autoCountDialogVisible" title="注水">
      <el-form :model="temp" label-width="90px">
        <el-form-item label="增加点赞数">
          <el-input placeholder="请输入点赞数" v-model="temp.zan"></el-input>
        </el-form-item>
        <el-form-item label="增加观看数">
          <el-input placeholder="请输入观看数" v-model="temp.watch"></el-input>
        </el-form-item>
        <el-form-item label="增加转发数">
          <el-input
            placeholder="请输入转发数"
            v-model="temp.forward"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button
          @click="autoCountDialogVisible = false"
          v-if="menuPerm('news:zhushui')"
          >返回</el-button
        >
        <el-button
          @click="onSubmit"
          type="primary"
          v-if="menuPerm('news:zhushui')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
var token = localStorage.getItem("key");
import { baseURL } from "../api/config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { formatDate } from "../plugins/formdata";
import { quillEditor } from "vue-quill-editor";
import { Modal } from "iview";
import Clipboard from "clipboard";
import VideoBlot from "../utils/video.js";
Quill.register(VideoBlot);

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ["8px", "small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image", "video"], // 链接、图片、视频
];

export default {
  name: "News",
  components: { quillEditor },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "info",
        deleted: "danger",
      };
      return statusMap[status];
    },
    typeFilter(type) {
      return calendarTypeKeyValue[type];
    },
  },
  data() {
    var self2 = this;
    var banImgs = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.bannerImageUrl == "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };

    var fengImgs = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.faceImg == "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };

    var queilContent = (rule, value, callback) => {
      // 图片验证
      // alert(this.editList.content)
      if (this.editList.content == "" || this.editList.content == undefined) {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };

    return {
      //添加页面校验：
      rulesAdd: {
        newsTitle: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        zhaiyao: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        banImg: [{ required: true, validator: banImgs, trigger: "blur" }],
        fengImg: [{ required: true, validator: fengImgs, trigger: "blur" }],
        source: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        menuName: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        content: [{ required: true, validator: queilContent, trigger: "blur" }],
        authorData: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
      },
      value: "",
      // -------------------------------------------
      homeIn: "",
      homeInOn: [
        {
          value: "0",
          label: "不上首页",
        },
        {
          value: "1",
          label: "上首页",
        },
      ],
      roledUser: "", //用户
      editUserOpen: false, //编辑不可点击
      //角色：
      reviewerUser: true, //审核者
      publisherUser: true, //发布者
      // ******************
      author: "", //作者
      authorData: "", //作者双向
      activeName: "", //视频链接

      // **********************
      labelPosition: "right", //表单对齐
      indexs: "", //注水下标
      inds: "", //权重下标
      times: "", //权重时间
      list: "", //表格数据
      sorts: "", //修改权重
      favorCount: "", //点赞数
      newId: "", //新闻id
      watchCount: "", //观看数
      totalCount: 0,
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      expectMenuId: "", //期望位置
      sourceExplain: "",
      pushValue: "",
      dialogVisibleFace: "", //编辑页删除上传图片
      isBlock: false,
      status1: "",
      status2: "",
      status3: "",
      status4: "",
      editImg: [],
      editBanner: [], //编辑页上传轮播图
      rowId: "", //编辑页提交id
      nickId: [], //发布账号
      pubListName: "", //发布者
      selectValue: "",
      sortTime: "", //排序搜索
      ruleForm: {
        desc: "",
      },
      frontCover: [], //上传封面图
      disabled: false, //控制上传图片
      reviewHistoryList: "", //审核意见
      // reviewHistoryList: "", // 审核时间
      addimgList: [],
      imgList: [],
      newsList: [], // 列表集合
      isShow: true,
      formLabelWidth: "120px",
      viewShow: false,
      isHot: true,
      isLunbo: false,
      isTop: false,
      //显示插入视频链接弹框的标识
      videoUploadTag: false,
      //弹框插入的视频链接记录
      videoLink: "",
      editorOption: {
        placeholder: "请输入...",
        theme: "snow",
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector(".avatar-uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: function (value) {
                if (value) {
                  self2.videoUploadTag = true;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      hideUploadCard: false, // 控制上传banner图的个数
      imageUrl: "",
      dialogVisible: false,
      dialogImageUrl: [],
      rules: {
        title: [{ required: true, message: "标题必填", trigger: "blur" }],
      },
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      liuyanDialogVisible: false, // 留言版
      autoCountDialogVisible: false, // 注水
      modifydialogVisible: false, //点赞数
      timedialogVisible: false, //时间权重
      statusOptions: ["published", "draft", "deleted"],
      temp: {
        newsTitle: "",
        newsContent: "",
        expectIsHot: "",
        expectIsRotation: "",
        expectIsHotspot: "",
        frontCoverType: "",
        source: "", // 来源
        sourceExplain: "", // 来源说明
        files: [], //
        imgFile: "",
        expectIsRecommend: false,
        remark: "",
        tsposition: "",
        fileUrls: "",
        ssDate: "",
        shDate: "",
        yijian: "",
        nickName: "admin", // 预览所用字段
        zan: 1000, // 点赞数
        watch: 2000, //  观看数
        forward: 3000, // 转发数
        fmStyle: 1, //样式控制
      },
      dialogStatus: "",
      textMap: {
        // update: "编辑",
        // create: "新增"
        // view: '查看'
      },
      positions: "", //发布位置
      value1: "",
      tableKey: 0,
      total: "0",
      listLoading: true,
      newsStatus: [
        {
          value: "2",
          label: "未提交审核",
        },
        {
          value: "3",
          label: "审核中",
        },
        {
          value: "4",
          label: "审核未通过",
        },
        {
          value: "1",
          label: "审核通过",
        },
      ],
      sortData: [
        {
          value: "create_date",
          label: "创建时间",
        },
        {
          value: "sort",
          label: "权重",
        },
      ],
      listQuery: {
        title: "",
        position: "",
        fbposition: "",
      },
      list: [],
      currentPage: 1, //初始页
      pagesize: 10, //每页数据
      editList: [],
      auditTime: [], //修改list数组的值

      multipleSelection: [], //批量审核
      examId: [], //批量审核id
      bannerImageUrl: "",
      faceImg: [],
      examineStatus: "",
      show: "",
      user: "",
      shenhe: false,
      fabu: false,
      reviewStatus: "", //审核状态
      baseBannerUrl: [], //编辑页上传banner图
      baseFacepicUrl: [], //编辑页上传封面图
      coverListPost: [], //传给后台的图片
      imgUrlpost: "", //传给后台的banner图
      newsContent: "", //编辑页新闻内容
      sourceExplain: "", //编辑页备注
      newsInfoImgList: [],
      zhaiyao: "",
      startTime: "",
      endTime: "",
      menuId: "", //审核期望位置id
      changeSelect: false,
      iframeUrl: "",
      fileList: [],
      editchange: false,
      editorContent: "",
      // 流程-----
      editOpen: false, //发布者--编辑按钮
      examId: "", //点击审核id
      clickOpen: "", //审核点击按钮
      imgArr: [], //从内容里选封面图
      visible: false, //内容封面图的弹框,
      changeContentImg: [], //选择的封面图
      myHeaders: { token: this.$store.state.token },
      disabledValue: false, //上传图片是否禁用
      visibleEdit: false,
      falseNewsContent: "",
      localVideo: "", //上传本地视频
      changeTimeVisible: false, //修改时间的model
      timeValue: "",
      changeTimeId: "",
    };
  },
  created() {
    this.roledUser = localStorage.getItem("login"); //用户
    // this.getList();
    this.handleUserList();
    // this.getNickName();
    this.getUser();
    this.getAuthor(); //作者

    var roled = localStorage.getItem("login");
    // reviewerUser:true,//审核者
    //   publisherUser:true,//发布者
    if (roled == "reviewer") {
      this.reviewerUser = false; //审核者
    } else if (roled == "publisher") {
      this.publisherUser = false; //发布者
    }
  },
  mounted() {
    this.getList();
    // 推送位置 期望位置接口

    this.getAxios("/menu/list").then((res) => {
      if (res.success == true) {
        this.positions = res.content;
      } else if (!res.success && res.statusCode == "401") {
        this.$message.error(res.message);
        this.$router.push("/");
      } else if (res.success == false) {
        this.$message.error(res.message);
      }
    });
  },
  methods: {
    changeTime(id) {
      this.changeTimeVisible = true;
      this.changeTimeId = id;
    },
    previewFile(file) {
      // console.log(file);
    },
    // 上传本地视频
    videoChange(file, fileList, event) {
      this.insertEle("video", file.file.response.entity); //方法，插入图片到富文本
    },
    insertEle(type, url) {
      let quill = this.$refs.myTextEditor.quill;
      //  当编辑器中没有输入文本时，这里获取到的 range 为 null
      var range = this.$refs.myTextEditor.quill.getSelection();
      // 视频插入在富文本中的位置
      var index = 0;
      if (range == null) {
        index = 0;
      } else {
        index = range.index;
      }
      // 插入视频  response.data.url为服务器返回的图片地址
      if (type === "video") {
        this.$refs.myTextEditor.quill.insertEmbed(index, "simpleVideo", {
          url,
          controls: "controls",
          width: "100%",
          height: "200px",
          poster: url + "?x-oss-process=video/snapshot,t_1,f_jpg,m_fast",
        });
      }
      // 调整光标到最后
      this.$refs.myTextEditor.quill.setSelection(index + 1);
      this.videoUploadTag = false;
    },
    //线上新增流程：
    //下拉框状态--编辑按钮--发布者：
    selectStatus(val) {
      if (val == "2" || val == "4") {
        this.editOpen = false;
      } else if (val == "1" || val == "3") {
        this.editOpen = true;
      }
    },

    // ---------------------以前的报错
    videoSelectTagClick() {}, //视频链接
    beforeRemove() {}, //上传轮播
    handleSuccess() {},

    // ---------------------现有的方法

    //添加取消
    addClose() {
      this.faceImg = [];
      this.changeContentImg = [];
      this.imgList = [];
      this.$router.go(0);
    },
    //复制文本：
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      // 　　　var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");

        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    // 添加发布页面
    getissue(formName) {
      // if (this.changeContentImg) {
      //   this.changeContentImg.map((i) => {
      //     this.faceImg.push(i.url);

      //   });
      // }
      this.faceImg = [];
      this.changeContentImg.map((i) => {
        this.faceImg.push(i.url);
      });
      this.$refs[formName].validate((valid) => {
        if (valid) {
          localStorage.setItem("addMenuId", this.editList.menuName);
          // if (this.editList.isHot == null) {
          //   this.editList.isHot = 0;
          // }
          // if (this.editList.isRotation == null) {
          //   this.editList.isRotation = 0;
          // }
          if (this.editList.isHotspot == null) {
            this.editList.isHotspot = 0;
          }
          if (this.editList.isRecommend == null) {
            this.editList.isRecommend = 0;
          }
          this.postAxios("/news/publish", {
            publisherId: this.editList.authorData, //作者
            newsTitle: this.editList.newsTitle,
            newsContent: this.editList.content,
            menuId: Number(this.editList.menuName),
            // isRotation: Number(this.editList.isRotation), //是否轮播
            isHotspot: Number(this.editList.isHotspot), //是否热点
            frontCoverType: this.temp.fmStyle, //添加封面样式
            source: this.editList.source,
            sourceExplain: this.editList.sourceExplain,
            coverList: this.faceImg,
            // imgFile: this.bannerImageUrl,
            zhaiyao: this.editList.zhaiyao,
            isRecommend: Number(this.editList.isRecommend), //是否首页
            // publisherMessage: this.editList.publisherMessage
          }).then((res) => {
            if (res.success == false) {
              this.$message.error(res.message);
              // this.dialogFormVisible1 = false;
            } else if (res.success == true) {
              this.$message.success("添加成功！");

              this.dialogFormVisible1 = false;

              this.getList();

              this.$router.go(0);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    //作者：
    getAuthor() {
      this.getAxios("/manager/list/userInfo", {
        managerId: localStorage.getItem("userId"),
      }).then((res) => {
        if (res.success == true) {
          this.author = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%";
      } else {
        return "";
      }
    },
    addVideoLink(type) {
      if (this.videoLink.length == 0) {
        alert("请输入视频链接");
      }
      //当编辑器中没有输入文本时，这里获取到的 range 为 null
      var range = this.$refs.myTextEditor.quill.getSelection();
      //视频插入在富文本中的位置
      var index = 0;
      if (range == null) {
        index = 0;
      } else {
        index = range.index;
      }
      //隐藏弹框
      this.videoUploadTag = false;
      //将视频链接插入到当前的富文本当中
      ///以引号分隔嵌入的视频代码 如下图中有分析
      var list = this.videoLink;
      let data = list.split(" ");
      let obj = {};
      var str = "==";
      data.map((item) => (obj[item.split("=")[0]] = item.split("=")[1] || ""));
      var url = obj.src + str;
      var urlName = url.slice(1);
      this.$refs.myTextEditor.quill.insertEmbed(index, "video", urlName);
    },
    // 上传服务器成功后
    upSuccess(file) {
      console.log(file);
      if (file.success == false && file.statusCode == 401) {
        this.$message.error(file.message);
      } else if (file.success == false) {
        this.$message.error(file.message);
      } else {
        if (this.faceImg.length > 1) {
          this.faceImg.map((i) => {
            if (i != file.entity) {
              this.faceImg.push(file.entity);
            }
          });
        } else if (this.faceImg.length == 0) {
          this.faceImg.push(file.entity);
        }

        this.changeContentImg.push({
          url: file.entity,
        });
      }
    },
    // 从内容中选择封面图
    contentImg(i, val) {
      if (val == "edit") {
        this.imgList.push({
          url: i,
        });
        this.coverListPost = [];
        this.imgList.map((i) => {
          this.coverListPost.push(i.url);
        });
      }
      this.changeContentImg.push({
        url: i,
      });
      this.visible = false;
      this.visibleEdit = false;
    },
    showModal(val) {
      if (val == "edit") {
        this.visibleEdit = true;
        // var str = this.newsContent;
        // this.imgArr = [];
        // if (str.indexOf('="') != -1) {
        //   var imgStr = str.split('="');
        //   imgStr.map((i) => {
        //     if (i.indexOf('">') != -1) {
        //       this.imgArr.push(i.split('">')[0]);
        //       this.coverListPost.push(i.split('">')[0]);
        //     }
        //   });
        // }
      } else {
        this.visible = true;
      }
    },
    hideModal(val) {
      if (val == "edit") {
        this.visibleEdit = false;
      } else {
        this.visible = false;
      }
    },
    editClose() {
      this.$router.go(0);
    },
    //富文本编辑改变事件
    onEditorChange({ editor, html, text }, val) {
      if (val == "add") {
        var str = html;
        this.imgArr = [];
        if (str.indexOf('="') != -1) {
          var imgStr = str.split('="');
          imgStr.map((i) => {
            if (i.indexOf('">') != -1) {
              this.imgArr.push(i.split('">')[0]);
            }
          });
        }
      }
      if (val == "edit") {
        var str = html;
        this.imgArr = [];
        if (str.indexOf('="') != -1) {
          var imgStr = str.split('="');
          imgStr.map((i) => {
            if (i.indexOf('">') != -1) {
              this.imgArr.push(i.split('">')[0]);
            }
          });
        }
      }

      this.content = html;
      this.editchange = true;
      this.editorContent = html;
      if (this.editList.content != "" || this.editList.content != undefined) {
        this.$refs.contented.clearValidate();
      }
    },
    //当用户点击富文本框输入框的时候，就会被设置为禁止编辑
    onEditorFocus(event) {
      event.enable(false);
    },
    //富文本图片上传前
    beforeUpload() {
      this.quillUpdateImg = true;
    },
    uploadSuccess(res, file) {
      let quill = this.$refs.myTextEditor.quill;
      //如果上传成功
      if (res.statusCode == 200) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片 res.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.entity);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else if (!res.success && res.statusCode == "401") {
        // alert(res.message);
        this.$message.error(res.message);
        this.$router.push("/");
      } else if (res.success == false) {
        this.$message.error(res.message);
      }
      //loading动画消失
      this.quillUpdateImg = false;
    },
    //富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片插入失败");
    },
    false() {
      dialogFormVisible = false;
    },
    // 审核不通过
    noToExamine() {
      if (!isNaN(this.editList.menuName)) {
      } else {
        this.editList.menuName = localStorage.getItem("menuId");
      }
      this.reviewStatus = 4;

      this.postAxios("/news/review", {
        newsInfoId: this.rowId,
        // isHot: this.status3, //是否置顶
        // isHot: this.editList.isRotation, //是否置顶-----
        // isRotation: this.status2, //是否轮播
        // isRotation: this.editList.isHot, //是否轮播---
        // isHotspot: this.status1, //是否是热点
        isHotspot: this.editList.isHotspot, //是否是热点--
        isRecommend: 0, //是否首页
        reviewStatus: this.reviewStatus,
        menuId: this.editList.menuName,
        opinion: this.reviewHistoryList,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);

          this.getList();
          this.dialogFormVisible2 = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
          this.dialogFormVisible2 = true;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
      this.getList();
    },
    examClose() {
      this.editBanner = [];
    },
    // 审核通过
    toExamine() {
      if (!isNaN(this.editList.menuName)) {
      } else {
        this.editList.menuName = localStorage.getItem("menuId");
      }

      if (this.editList.isRecommend == null) {
        this.editList.isRecommend = 0;
      }
      this.reviewStatus = 1;

      this.postAxios("/news/review", {
        newsInfoId: this.rowId,
        // isHot: this.editList.isHot, //是否置顶-----
        // isRotation: this.status2, //是否轮播
        // isRotation: Number(this.editList.isRotation), //是否轮播---
        // isHotspot: this.status1, //是否是热点
        isHotspot: this.editList.isHotspot, //是否是热点--
        // isRecommend: this.status4, //是否首页
        isRecommend: this.editList.isRecommend, //是否首页------
        reviewStatus: this.reviewStatus,
        menuId: this.editList.menuName,
        opinion: this.reviewHistoryList,
      }).then((res) => {
        if (res.message == "操作成功") {
          this.$message.success("审核成功");
          this.dialogFormVisible2 = false;
          this.getList();
        } else if (res.success == false) {
          this.dialogFormVisible2 = true;
          this.$message.error(res.message);
        }
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //判断角色
    getUser() {
      var user = localStorage.getItem("");
      this.user = user;
      if (this.user == "reviewer") {
        this.shenhe = true;
        this.fabu = false;
      } else if (this.user == "publisher") {
        this.fabu = true;
        this.shenhe = false;
      }
    },
    // 添加发布时点击取消
    addFalse() {
      this.show = !this.show;
    },
    // faceImgUrl(file, fileList) {
    //   var res = this.getBase64(file);
    //   this.getBase64(file).then((resBase64) => {
    //     this.faceImg.push(resBase64);
    //     if (this.faceImg != "") {
    //       this.$refs.fengImg.clearValidate();
    //     }
    //   });
    // },
    bannerImg(file, fileList) {
      var res = this.getBase64(file);
      this.getBase64(file).then((resBase64) => {
        this.bannerImageUrl = resBase64;
        if (this.bannerImageUrl != "") {
          this.$refs.banImg.clearValidate();
        }
      });
    },
    //转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    handleAvatarSuccess(res, file) {
      alert("上传成功");
    },
    //点击查询功能
    searchNewsList() {
      this.currentPage = 1;
      var title = this.listQuery.title,
        // account = this.pubListName, //发布账号
        expectPos = this.listQuery.position, //期望位置
        issuePos = this.listQuery.fbposition, //发布位置
        saveTime = this.value1, //保存时间
        status = this.selectValue; //状态

      if (this.value1 == null) {
        this.startTime = "";
        this.endTime = "";
      } else {
        (this.startTime = new Date(saveTime[0]).getTime() / 1000),
          (this.endTime = new Date(saveTime[1]).getTime() / 1000);
      }
      this.postAxios("/news/list", {
        pageNum: 1,
        pageSize: this.pagesize,
        newsTitle: title, //
        menuId: issuePos, //发布位置
        expectMenuId: expectPos, //期望位置
        // publisherId: account, // 发布者的id
        examineStatus: status,
        createTimestampStart: this.startTime, // 时间范围查询开始时间
        createTimestampEnd: this.endTime, // 时间范围查询结束时间
        sortField: this.sortTime, //排序权重
        isRecommend: this.homeIn, //1上首页推荐，否则传空
      }).then((res) => {
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == true) {
          this.list = res.content;
          this.list.forEach((item, index) => {
            item.disabled = false;
          });
          this.totalCount = res.totalCount;

          // 时间戳转时间
          this.list.map((i, index) => {
            if (i.examineStatus == "1") {
              this.examineStatus = "审核通过";
            } else if (i.examineStatus == "2") {
              this.examineStatus = "未提交审核";
            } else if (i.examineStatus == "3") {
              this.examineStatus = "审核中";
            } else if (i.examineStatus == "4") {
              this.examineStatus = "审核未通过";
            } else {
              this.examineStatus = "下架";
            }
            if (i.reviewTimestamp != null) {
              var timeTrans = new Date(parseInt(i.reviewTimestamp) * 1000);
              let reviewTimestamp = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });
              this.$set(this.list[index], `createTimestamp`, reviewTimestamp);
            } else {
              this.$set(this.list[index], `createTimestamp`, "");
            }

            if (
              i.submitReviewTimestamp != null &&
              i.submitReviewTimestamp != 0
            ) {
              var timeTrans = new Date(
                parseInt(i.submitReviewTimestamp) * 1000
              );
              let time = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });

              this.$set(this.list[index], `submitReviewTimestamp`, time);
            } else {
              this.$set(this.list[index], `submitReviewTimestamp`, "");
            }

            if (i.sort != null && i.sort != 0) {
              var timeTrans = new Date(parseInt(i.sort) * 1000);
              let revieTime = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });

              this.$set(this.list[index], `sort`, revieTime);
            } else {
              this.$set(this.list[index], `sort`, "");
            }
          });
        }
      });
    },
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //修改时间
    handleTime(ind) {
      this.inds = ind;
      this.timedialogVisible = true; // 弹框
      this.sorts = this.list[ind].sort; // 权重(v-model)
      var daa = new Date(this.sorts);
    },
    TimeSelect(time) {
      var time3 = Date.parse(time);
      this.timeValue = time3;
    },
    sureChangeTime() {
      this.getAxios("/news/set/time", {
        id: this.changeTimeId,
        time: this.timeValue / 1000,
      }).then((res) => {
        this.timeValue = "";
        if (res.success) {
          this.changeTimeVisible = false;
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // change改变时间
    TimeChange(time) {
      this.formatDateTime(time);
    },
    //弹框修改时间
    EditTime() {
      if (this.sorts == "") {
        this.list[this.inds].sort == "";
      }
      this.newId = this.list[this.inds].id; //新闻id
      var date = new Date(this.sorts);

      this.times = date.getTime() / 1000;
      this.getAxios("/news/update/sort", {
        sort: this.times,
        newsInfoId: this.newId,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("修改成功");
          this.timedialogVisible = false;
          var timed = new Date(this.times * 1000).toLocaleString("chinese", {
            hour12: false,
          });
          this.list[this.inds].sort = timed;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
          this.timedialogVisible = false;
        }
      });
    },
    // 查询时时间选择器
    changTime() {},
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleUserList() {
      this.getList();
    },

    //新闻列表
    getList() {
      var title = this.listQuery.title,
        // account = this.pubListName, //发布账号
        expectPos = this.listQuery.position, //期望位置
        issuePos = this.listQuery.fbposition, //发布位置
        saveTime = this.value1, //保存时间
        status = this.selectValue; //状态
      if (this.value1 == null) {
        this.startTime = "";
        this.endTime = "";
      } else {
        (this.startTime = new Date(saveTime[0]).getTime() / 1000),
          (this.endTime = new Date(saveTime[1]).getTime() / 1000);
      }
      this.postAxios("/news/list", {
        pageNum: this.currentPage,
        pageSize: this.pagesize,
        newsTitle: title, //
        menuId: issuePos, //发布位置
        expectMenuId: expectPos, //期望位置
        // publisherId: account, // 发布者的id
        examineStatus: status,
        createTimestampStart: this.startTime, // 时间范围查询开始时间
        createTimestampEnd: this.endTime, // 时间范围查询结束时间
      }).then((res) => {
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == true) {
          this.list.forEach((item, index) => {
            item.disabled = false;
          });
          this.totalCount = res.totalCount;
          this.list = res.content;
          // 时间戳转时间
          this.list.map((i, index) => {
            if (i.examineStatus == "1") {
              this.examineStatus = "审核通过";
            } else if (i.examineStatus == "2") {
              this.examineStatus = "未提交审核";
            } else if (i.examineStatus == "3") {
              this.examineStatus = "审核中";
            } else if (i.examineStatus == "4") {
              this.examineStatus = "审核未通过";
            } else {
              this.examineStatus = "下架";
            }
            if (i.reviewTimestamp != null) {
              var timeTrans = new Date(parseInt(i.reviewTimestamp) * 1000);
              let reviewTimestamp = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });
              this.$set(this.list[index], `createTimestamp`, reviewTimestamp);
            } else {
              this.$set(this.list[index], `createTimestamp`, "");
            }

            if (
              i.submitReviewTimestamp != null &&
              i.submitReviewTimestamp != 0
            ) {
              var timeTrans = new Date(
                parseInt(i.submitReviewTimestamp) * 1000
              );
              let time = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });

              this.$set(this.list[index], `submitReviewTimestamp`, time);
            } else {
              this.$set(this.list[index], `submitReviewTimestamp`, "");
            }

            if (i.sort != null && i.sort != 0) {
              var timeTrans = new Date(parseInt(i.sort) * 1000);
              let reviewTimestampsd = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });

              this.$set(this.list[index], `sort`, reviewTimestampsd);
            } else {
              this.$set(this.list[index], `sort`, "");
            }
          });
        }
      });
    },

    handleStatusChange(index, row) {
      this.$confirm("是否要修改该状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消修改",
          });
          this.getList();
        });
    },
    handleLunboStatusChange() {
      this.$confirm("是否要修改该状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateStatus(row.id, { status: row.status }).then((response) => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消修改",
          });
          this.getList();
        });
    },
    handleTopStatusChange() {
      this.$confirm("是否要修改该状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateStatus(row.id, { status: row.status }).then((response) => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消修改",
          });
          this.getList();
        });
    },
    onSubmit() {},
    checkPass() {
      this.passtype = true;
      this.isShow = false;
    },
    //上传删除
    handleRemove(file, fileList) {
      this.hideUploadCard = fileList.length >= 3;
    },
    handleChange(file, fileList) {
      this.hideUploadCard = fileList.length >= 3;
    },
    // app推送
    push(row) {
      this.getAxios("/app/push", {
        type: 1,
        id: row.id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == false && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //点击审核获取详情
    handleUpshenhe(row) {
      this.dialogFormVisible2 = true;
      this.isBlock = true;
      this.getAxios(`/news/detail/${row.id}`).then((res) => {
        localStorage.setItem("menuId", res.entity.menuId);
        if (res.message == false) {
          this.$message.error(res.message);
        }
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
        if (res.entity.imgUrl) {
          this.editBanner.push({
            url: res.entity.imgUrl,
          });
        }
        this.rowId = row.id;
        this.editList.isHotspot = res.entity.isHotspot;
        // this.editList.isHot = res.entity.isHot; //置顶
        // this.editList.isRotation = res.entity.isRotation;
        this.editList.isRecommend = res.entity.isRecommend; //是否首页
        this.temp.fmStyle = res.entity.frontCoverType;
        this.editList = res.entity;
        this.zhaiyao = res.entity.zhaiyao;
        this.editList.content = res.entity.newsContent;
        this.falseNewsContent = res.entity.newsContent;
        this.imgList = [];
        res.entity.newsInfoImgList.forEach((item) => {
          this.imgList.push({ url: item.imgUrl });
        });
        res.entity.reviewHistoryList.forEach((item) => {
          this.reviewHistoryList = item.opinion;
        });
        Array.from(this.editList).map((i, index) => {
          // 转换提交审核的时间
          var unixTimestamp = new Date(
              i.submitReviewTimestamp
            ).toLocaleString(),
            commonTime = unixTimestamp.toLocaleString();
          this.auditTime.push({
            time: commonTime,
          });
          // 审核时间
          var unixReviewTimestamp = new Date(
              i.reviewTimestamp
            ).toLocaleString(),
            commonTimestamp = unixReviewTimestamp.toLocaleString();
          this.$set(this.list[index], `submitReviewTimestamp`, commonTime);
          this.$set(this.list[index], `reviewTimestamp`, commonTimestamp);
        });
      });
    },

    //点赞数弹框
    handleModify(ind) {
      this.indexs = ind;
      this.modifydialogVisible = true;
      this.favorCount = this.list[ind].favorCount; //点赞数
      this.watchCount = this.list[ind].watchCount; //观看数
      this.newId = this.list[ind].id; //新闻id
    },
    //注水弹框刷新页面
    handleCancel() {
      this.$router.go(0);
    },
    //修改点赞数：
    handleFavor(e) {
      this.getAxios("/news/update/favorCount", {
        count: this.favorCount,
        newsInfoId: this.newId,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("修改成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //修改观看数：
    handleWatch(e) {
      this.getAxios("/news/update/watchCount", {
        count: this.watchCount,
        newsInfoId: this.newId,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("修改成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //发布者-点击编辑
    handleUpdate(row) {
      // this.$router.back('/new')
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.getAxios(`/news/detail/${row.id}`).then((res) => {
        // pushId
        if (res.message == false) {
          this.$message.error(res.message);
        }
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }

        if (res.success == true) {
          this.newsInfoImgList = res.entity.newsInfoImgList;
          this.newsContent = res.entity.newsContent;
          this.pushValue = res.entity.expectMenuName;
          this.sourceExplain = res.entity.sourceExplain;
          this.expectMenuId = res.entity.expectMenuId;
          this.zhaiyao = res.entity.zhaiyao;
          this.editBanner = [];
          if (res.entity.imgUrl == "" || res.entity.imgUrl == null) {
            this.editBanner = []; //编辑--轮播图
          } else {
            this.editBanner.push({
              url: res.entity.imgUrl,
            });
          }
          this.rowId = row.id;
          this.temp.fmStyle = res.entity.frontCoverType;
          this.editList = res.entity;
          this.imgList = [];
          localStorage.setItem("addMenuId", res.entity.menuId);
          this.coverListPost = [];
          res.entity.newsInfoImgList.forEach((item) => {
            this.imgList.push({ url: item.imgUrl });
            this.coverListPost.push(item.imgUrl);
          });
          res.entity.reviewHistoryList.forEach((item) => {
            this.reviewHistoryList = item.opinion;
          });
          Array.from(this.editList).map((i, index) => {
            // 转换提交审核的时间
            var unixTimestamp = new Date(
                i.submitReviewTimestamp * 1000
              ).toLocaleString(),
              commonTime = unixTimestamp.toLocaleString();
            this.auditTime.push({
              time: commonTime,
            });
            // 审核时间
            var unixReviewTimestamp = new Date(
                i.reviewTimestamp * 1000
              ).toLocaleString(),
              commonTimestamp = unixReviewTimestamp.toLocaleString();
            this.$set(this.list[index], `submitReviewTimestamp`, commonTime);
            this.$set(this.list[index], `reviewTimestamp`, commonTimestamp);
          });
        }
      });
    },
    //发布者- 提交审核：
    handleExamine(row) {
      this.examId = row.id; //审核id
      this.getAxios(`/news/submit/review/${row.id}`, {}).then((res) => {
        if (res.success == true) {
          this.$message.success("提交审核成功！");
          this.getList();
        } else if (res.success == false) {
          this.$message.error(res.message);

          row.disabled = false;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },

    beforeAvatarUpload(file) {
      this.wenjian = file;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "jpg";
      const extension2 = testmsg === "png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是 jpg、png格式",
          type: "warning",
        });
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过10MB",
          type: "warning",
        });
      }
      return extension || (extension2 && isLt2M);
    },

    createData() {
      this.$refs["dataForm"].validate((valid) => {
        if (!valid) {
          return this.$message.error("请填写必要的表单项！");
        }
        this.$message.success("添加商品成功！");
        this.dialogFormVisible = false;
        this.$router.push("/news");
      });
    },
    //编辑页上传banner图片
    uploadBanner(file, fileList) {
      var res = this.getBase64(file);
      //讲上传的banner图转base64格式
      this.getBase64(file).then((resBase64) => {
        this.baseBannerUrl.push(resBase64);
        if (this.baseBannerUrl) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.baseBannerUrl,
          }).then((res) => {
            if (res.success == true) {
              this.editBanner = res.content[0];
              localStorage.setItem("name", this.editBanner);
            }

            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            } else if (res.success == false) {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    //删除上传轮播图
    removeBanner(file, fileList) {
      var res = this.getBase64(file);
      this.editBanner = "";
    },
    //编辑页上传banner图限制提示
    handleExceed(files, fileList) {
      this.$message.warning(`当前图片限制1张`);
    },
    //添加时删除上传封面图
    removeFace(file, fileList) {
      this.faceImg = [];
      this.changeContentImg = [];
      if (fileList.length >= 1) {
        fileList.map((i) => {
          this.faceImg.push(i.url);
          this.changeContentImg.push({
            url: i.url,
          });
        });
      }
    },
    //删除上传封面图
    removeFacepic(file, fileList) {
      this.coverListPost = [];
      this.imgList = [];
      fileList.map((i) => {
        this.coverListPost.push(i.url);
        this.imgList.push({
          url: i.url,
        });
      });
    },
    removePreview(file) {
      console.log(file, "---");
      this.dialogImageUrl = file.url;
      this.dialogVisibleFace = true;
    },
    //编辑上传图片
    editSuccess(file) {
      if (file.success == false) {
        this.$message.error(file.message);
      } else if (file.success == false && file.statusCode == 401) {
        this.$message.error(file.message);
        this.$router.push("/");
      } else {
        this.coverListPost.push(file.entity);
      }
    },
    // 提交编辑页面
    updateData() {
      var imgurls = localStorage.getItem("name");
      if (imgurls == "" && imgurls == null) {
        imgurls = "";
      } else if (imgurls) {
        imgurls = imgurls;
      }

      if (this.editchange) {
        this.newsContent = this.editorContent;
      }
      if (!isNaN(this.editList.menuName)) {
      } else {
        this.editList.menuName = localStorage.getItem("addMenuId");
      }
      this.postAxios("/news/edit", {
        newsTitle: this.editList.newsTitle,
        newsContent: this.newsContent,
        menuId: this.editList.menuName, //期望发布的位置
        // isHot: this.editList.isHot,
        // isRotation: this.editList.isRotation,
        isHotspot: this.editList.isHotspot,
        isRecommend: this.editList.isRecommend, //是否首页
        frontCoverType: this.temp.fmStyle,
        source: this.editList.source,
        // sourceExplain: this.sourceExplain,
        coverList: this.coverListPost, //this.coverListPost
        id: this.rowId,
        zhaiyao: this.zhaiyao,
        // imgFile: this.editBanner,
        imgFile: imgurls,
        // publisherMessage: this.editList.publisherMessage,
        publisherId: this.editList.publisherId, //作者
      }).then((res) => {
        if (res.message == "操作成功" || res.success == true) {
          this.$message.success("编辑发布成功");
          this.dialogFormVisible = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
          this.dialogFormVisible = true;
        } else {
          this.$message.error(res.message);
          this.dialogFormVisible = true;
          this.$router.go(0);
        }
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
      this.getList();
    },
    // 生成海报
    poster(id) {
      this.getAxios("/news/generate/poster", {
        newsInfoId: id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //列表删除----
    handleDelete(row, index) {
      var that = this;
      this.$confirm({
        title: "确定要删除吗?",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          that
            .getAxios("/news/delete?newsInfoId=" + row)
            .then((res) => {
              if (res.success === true) {
                that.getList();
                that.$message.success("删除成功");
              }
            })
            .catch((error) => {
              this.$message({
                type: "info",
                message: "删除失败",
              });
            });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    handleCreate() {
      this.show = true;
      this.editList = [];
      this.zhaiyao = [];
      this.imgList = [];
      this.dialogFormVisible1 = true;
      this.faceImg = []; //封面图
      // this.changeContentImg=[];
      this.coverListPost = [];
    },

    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    //批量审核：
    handleSelectionChange(val) {
      this.multipleSelection = val;

      var ids = [];
      this.multipleSelection.forEach((item, index) => {
        ids.push(item.id);
      });
      this.examId = ids;
    },
    // 点击确认批量审核
    handleExamSubmit() {
      this.postAxios("/news/batch/review", {
        ids: this.examId,
        examineStatus: "1",
      })
        .then((res) => {
          if (res.success == true) {
            this.$message.success("批量审核通过！");
            this.$refs.multipleTable.clearSelection(); //取消选中
            this.getList();
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        })
        .catch((reason) => {
          this.$message.error("接口响应超时");
        });
    },
  },
};
</script>

<style scoped lang="less">
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  height: 148px;
}
.hide .el-upload--picture-card {
  display: none;
}

.tab-container {
  width: 100%;
  height: 100%;
  margin: 30px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.editor {
  line-height: normal !important;
  height: 800px;
}

.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}

.quillEditor /deep/ .ql-container {
  font-size: 16px !important;
}
.el-radio-group {
  display: inherit !important;
  margin-bottom: 10px !important;
}
.el-card {
  border: 1px solid #ebeef5;
  border-left: 0;
  background-color: #ffffff;
  overflow: hidden;
  color: #303133;
  transition: 0.3s;
}
/*设置文本框高度*/
.quillEditor {
  height: 600px !important;
}
.line {
  float: right;
  width: 100%;
  height: 2px;
  margin-top: -0.5em;
  background: #d4c4c4;
  position: relative;
  text-align: center;
}

.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
  display: flex;
}
.ant-btn-primary {
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.el-switch {
  display: inline-flex;
  align-items: center;
  position: relative;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  vertical-align: middle;
  margin-top: 10px;
}
.el-upload-list__item div > img {
  height: 148px !important;
}

.el-range-editor--small.el-input__inner {
  height: 32px;
  width: 400px !important;
}
.el-select {
  display: inline-block;
  position: relative;
  width: 200px !important;
}

/deep/ .el-dialog {
  position: relative;
  margin: 0 auto !important;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  width: 100% !important;
  overflow-x: auto !important;
}
/deep/ .el-icon-close {
  font-size: 38px;
  font-weight: bold;
}
/deep/ .el-dialog .el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  width: 730px;
}
/deep/ .el-dialog__wrapper {
  z-index: 2222 !important;
}

/deep/ .el-dialog .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 730px;
}

/deep/ .el-select .el-input__inner {
  cursor: pointer;
  padding-right: 35px;
  width: 200px;
}
/deep/ .el-date-editor .el-input__inner {
  width: 300px;
}
/deep/ .el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  width: 80px;
  margin-top: 10px;
}

/deep/ .dialog-footer .el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  width: 100px;
  margin-top: 10px;
  margin-left: 10px;
}
/deep/ .ant-message {
  z-index: 9999999 !important;
  font-size: 40px;
}

// /deep/.ant-modal-body {
//   display: flex;
//   flex-wrap: wrap;
// }
// /deep/ .ant-modal-body > div {
//   width: 120px;
//   height: 120px;
//   margin-right: 30px;
//   margin-top: 10px;
// }
/deep/ .ant-modal-content {
  z-index: 999999;
}
/deep/ .ant-modal-mask {
  z-index: 9999;
}
/deep/ .ant-modal-wrap {
  z-index: 99999999;
}
/deep/ .ant-modal {
  top: 200px;
}
/deep/ .ant-modal-body img {
  height: 120px;
  width: 120px;
  margin: 10px 10px;
}
// /deep/ .quills  .el-form-item__error {
//     color: #F56C6C;
//     font-size: 12px;
//     line-height: 1;
//     padding-top: 4px;
//     position: absolute;
//     top: 100%;
//     left: 0;
// }

/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: auto;
  height: 100%;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  margin: 0 8px 8px 0;
  display: inline-block;
  text-align: center;
}

/deep/.el-pagination .el-select .el-input__inner {
  cursor: pointer;
  padding-right: 35px;
  width: 120px;
}
.news_title {
  display: block;
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
